import React from 'react';
import PropTypes from 'prop-types';
import { pickWithPriority } from 'Helpers/Affordances';
import fr from 'facet-rest';
import AvailableResources from './AvailableResources';

const AvailableResourcesPicker = ({ tabResource }) => {
  return pickWithPriority(tabResource, [
    [fr.relationships.tabData.name, <AvailableResources tabDataRelationship={tabResource.relationship(fr.relationships.tabData.name)} />],
  ], () => null);
};

AvailableResourcesPicker.propTypes = {
  tabResource: PropTypes.object.isRequired,
};

export default AvailableResourcesPicker;
